const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Access more than 35 tools premium features across the full suite including Enhancer, Remover, AI translater, Screen Recorder, and more, available at one, affordable price.',
  Upgrade: 'Upgrade',
  Tools: 'araç seti',
  MyProjects: 'Benim dosyalarım',
  MyAccount: 'Hesabım',
  Subscription: 'abonelik',
  LogOut: 'Çıkış Yap',
  PopularTools: 'Popüler Araç Seti',
  Enhance: 'Genişletmek',
  Remove: 'Kaldırmak',
  Animate: 'Canlandır',
  Extract: 'Çıkarmak',
  SaveThreeDays:
    'Projeler 3 gün boyunca saklanır, lütfen işledikten sonra indirin.',
  All: 'Tüm',
  Video: 'Video',
  Image: 'resim',
  Audio: 'Ses',
  minutesAgo: 'dakika önce',
  hoursAgo: 'saatler önce',
  daysAgo: 'günler önce',
  Modified: 'Değiştirilmiş',
  Order: 'Emir',
  EarliestToLatest: 'En Erkenden En Sonuna',
  LatestToEarliest: 'En sondan en eskiye',
  NoProject: 'Proje Yok. ile hızlı başlangıç',
  OnlineTools: 'Çevrimiçi Araçlar.',
  AIVideoEnhancer: 'AI Video İyileştirici',
  Enhancer4K:
    "Videoları çevrimiçi olarak 4K'ya kadar geliştirmek için yapay zeka için tek tıklama",
  AIPhotoEnhancer: 'AI Fotoğraf İyileştirici',
  AIEnhancerImage:
    'AI, görüntüleri çevrimiçi olarak 8 kata kadar kayıpsız bir şekilde geliştirir',
  View: 'Görüş',
  Download: 'İndirmek',
  MultipleSelect: 'çoklu seçim',
  Delete: 'Silmek',
  SubscriptionHistory: 'Abonelik Geçmişi',
  NoValidSubscription: 'Geçerli abonelik yok.',
  veContent:
    "Videoları çevrimiçi olarak 4K'ya kadar geliştirmek için yapay zeka için tek tıklama",
  peContent:
    'AI, görüntüleri çevrimiçi olarak 8 kata kadar kayıpsız bir şekilde geliştirir',
  rmvContent: 'Videodan filigranı kaldır',
  rmttContent:
    'TikTok video filigranlarını göz açıp kapayıncaya kadar kaldırın',
  dynamicContent: 'Fotoğrafınızı çevrimiçi olarak canlandırın',
  rmbgContent: 'Görüntüden arka planı kaldır',
  youMayNeed: 'İhtiyacın olabilir',
  new: 'Yeni',
  loginYourAccount: 'HitPaw hesabınıza giriş yapın',
  signUpYourAccount: 'HitPaw hesabınıza kaydolun',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
